// 백엔드 API 기본 URL 설정
// 기본값은 프로덕션 HTTPS 도메인을 사용하고, 내부 개발 환경은 명시적인 env override로만 허용한다.
const INTERNAL_BASE_URL = import.meta.env.VITE_INTERNAL_API_BASE_URL || '';                   // 개발용일 경우 http://172.16.100.95, 아닐경우 ''
const EXTERNAL_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://erion.wenit.co.kr';   // 개발용일 경우 http://172.16.100.95, 아닐경우 https://erion.wenit.co.kr

// file:// 프로토콜 여부 (Flutter 앱 등)
const isFileProtocol =
  typeof window !== 'undefined' &&
  (window.location.protocol === 'file:' || window.location.origin === 'null');

// 내부망 여부 (172.16.x.x, 192.168.x.x, 10.x.x.x, localhost 등)
const isInternalNetwork =
  typeof window !== 'undefined' &&
  /^(localhost|127\.|10\.|192\.168\.|172\.(1[6-9]|2[0-9]|3[01])\.)/.test(window.location.hostname);

export const API_BASE_URL = ((isFileProtocol || isInternalNetwork) && INTERNAL_BASE_URL)
  ? INTERNAL_BASE_URL
  : EXTERNAL_BASE_URL;
